export default __webpack_public_path__ + "static/Development-architecture-design-323fba966059ffdc7084a24e83d30748.webp";